/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Word_UpInputs */

const en_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Word Up`)
};

const fr_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer un mot vers le haut`)
};

const de_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wort nach oben verschieben`)
};

const it_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la parola in alto`)
};

const ru_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместить слово вверх`)
};

const es_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover palabra hacia arriba`)
};

const zh_cn2_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向上移动单词`)
};

const ja_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語を上に移動`)
};

const hi_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द को ऊपर ले जाएं`)
};

const pt_pt2_shortcut_keys_name_move_word_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover a palavra para cima`)
};

/**
* | output |
* | --- |
* | "Move Word Up" |
*
* @param {Shortcut_Keys_Name_Move_Word_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_word_up = /** @type {((inputs?: Shortcut_Keys_Name_Move_Word_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Word_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_move_word_up(inputs)
	if (locale === "de") return de_shortcut_keys_name_move_word_up(inputs)
	if (locale === "it") return it_shortcut_keys_name_move_word_up(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_move_word_up(inputs)
	if (locale === "es") return es_shortcut_keys_name_move_word_up(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_move_word_up(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_move_word_up(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_move_word_up(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_move_word_up(inputs)
	return en_shortcut_keys_name_move_word_up(inputs)
});